module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-27.2f0502e3.svg";